import { environment } from 'src/environments/environment';

const base = `${environment.domain}/${environment.apiVersion}/assistant/provider`;

/** Laravel business API proxy for Truckit Assistant chat queries. */
export const ASSISTANT_QUERY_URL = `${base}/query`;

/** Laravel business API proxy for personalized suggestion chips. */
export const ASSISTANT_SUGGEST_URL = `${base}/suggest-query`;

/** agentic = chat + listings; filters = listing-search filter payload only. */
export type AssistantResponseType = 'agentic' | 'filters';

const ASSISTANT_REQUEST =
  /\/assistant\/(?:api\/)?provider\/(?:query|suggest-query)/;

export function isAssistantApiRequest(url: string): boolean {
  return ASSISTANT_REQUEST.test(url);
}

export function resolveAssistantApiUrl(url: string): string | null {
  if (!isAssistantApiRequest(url)) {
    return null;
  }

  return url.includes('suggest') ? ASSISTANT_SUGGEST_URL : ASSISTANT_QUERY_URL;
}

export function buildAssistantQueryBody(
  query: string,
  responseType: AssistantResponseType,
): { query: string; response_type: AssistantResponseType } {
  return { query, response_type: responseType };
}

/** Prefer explicit host attr on <ai-chat response-type="...">, then request body. */
export function resolveAssistantResponseType(
  fromBody?: unknown,
  fromElement?: string | null,
): AssistantResponseType {
  if (fromElement === 'agentic' || fromElement === 'filters') {
    return fromElement;
  }
  if (fromBody === 'agentic' || fromBody === 'filters') {
    return fromBody;
  }
  return 'agentic';
}

export function readAssistantResponseTypeFromDom(): AssistantResponseType | null {
  const value = document.querySelector('ai-chat')?.getAttribute('response-type');
  return value === 'agentic' || value === 'filters' ? value : null;
}
